<template>
	<div>
		<p class="inviter">好友邀请</p>
		<div class="remainder">
			<p class="remainderChild">我的余额<i>￥</i><span>{{total}}</span></p>
			<p class="seeDetail" @click="seeDetail">查看明细</p>
		</div>
		<div class="scancode">
			<img src="../../assets/soamaa.jpg" class="QRcode"/>
		</div>
		<div class="wholeBalance">
			<div class="wholeword">全部</div>
		</div>
		<div class="detailList">
			<div class="dates">日期</div>
			<div class="income">收入/支出</div>
			<div class="detailInfo">详细信息</div>
		</div>
		<div class="dateList" v-for="invites in invite">
			<div class="datesList">{{invites.date}}</div>
			<div class="incomeList">{{invites.value}}</div>
			<div class="detailInfoList">{{invites.remark}}</div>
		</div>
		<div class="clear"></div>
	</div>
</template>

<script>
	export default{
		name:"Invite",
		data(){
			return{
				invite:[],
				total:''
			}
		},
		methods:{
			seeDetail(){
				var mingxi=$(".wholeBalance").offset().top
				$(document).scrollTop(mingxi)
			}
		},
		mounted(){
			var that=this
			that.$ajax({
				method:"post",
				url:"/api/FriendInvite"
			}).then(function(data){
				that.invite=data.data.data
			}).catch(function(err){
				console.log(err)
			})
			that.$ajax({
				method:"post",
				url:"/api/FriendInviteCollect"
			}).then(function(data){
				that.total=data.data.result.ready
			}).catch(function(err){
				console.log(err)
			})
		}
	}
</script>

<style>
	.inviter{font-size: 20px;color:#4f4f4f;margin: 30px 0 20px 30px;}
	.remainder{width: 850px;height: 85px;background: #e6e8f0;margin-left: 30px;}
	.remainderChild{margin-left:30px;color: #4f4f4f;float: left;line-height: 85px;}
	.remainderChild span{font-size: 30px;color: #01b784;}
	.remainderChild i{font-style: normal;font-size: 24px;color: #01b784;margin-left: 20px;}
	.seeDetail{float: right;line-height: 85px;margin-right: 30px;color:#44aaff;}
	.scancode{width: 850px;height: 420px;margin: 16px 0 0 30px;background: url(../../assets/saoma.png)no-repeat;position: relative;}
	.QRcode{width: 175px;height: 175px;position: absolute;left: 340px;top: 40px;}
	.wholeBalance{height:62px;width: 850px;margin-left: 30px;border-bottom: 2px solid #e6e8f0;position: relative;}
	.wholeword{width: 90px;line-height:44px;border-bottom: 2px solid #01b784;text-align: center;color: #01b784;position: absolute;top: 16px;font-weight: 600;}
	.detailList{width: 850px;height: 40px;background: #f5f5f5;margin:30px 0 0 30px;color: #909090;}
	.dates{float: left;width:205px;text-align: center;line-height: 40px;}
	.income{float: left;width:206px;text-align: center;line-height: 40px;}
	.detailInfo{float: left;width: 420px;text-align: center;line-height: 40px;}
	.dateList{width: 850px;height: 50px;border-bottom:1px solid #e6e6e6;margin-left: 30px;color: #4f4f4f;}
	.datesList{float: left;width:205px;text-align: center;line-height: 50px;}
	.incomeList{float: left;width:206px;text-align: center;line-height: 50px;}
	.detailInfoList{float: left;width: 420px;text-align: center;line-height: 50px;}
	.clear{clear: both;}
	/*.router-link-active{background:#11cc99;color:#fff;}*/
</style>


// WEBPACK FOOTER //
// Invite.vue?17c69fc1